import { useProductContext } from "../context"

export const ProductName = () => {
  const { name } = useProductContext()

  if (!name) {
    return null
  }

  return <h1 className="font-product text-h2-np m-0 leading-none">{name}</h1>
}
